export const landingFaqTranslations = {
    en: {
        title: 'Frequently asked questions',
        subtitle: 'We are here to help you with any questions you may have. If you don\'t find what you need, please visit our',
        completeFaqLink: 'complete FAQ page',
        items: [
            {
                question: 'What is InvoiceHappens?',
                answer: 'InvoiceHappens is an effortlessly elegant invoicing platform designed specifically for entrepreneurs. It allows you to create and send invoices instantly with no sign-ups, no fees, and a beautiful, intuitive interface.'
            },
            {
                question: 'Is it really free?',
                answer: 'Yes, really! The first 100,000 entrepreneurs can invoice for free. No hidden costs, no freemium traps, and no complicated setups. We believe every entrepreneur deserves a simple, elegant way to invoice without paying a dime.'
            },
            {
                question: 'Do I need to create an account?',
                answer: 'No account is needed to start invoicing. Just start typing, and your invoice is ready in seconds. You can optionally use our 1-Click Cloud Sync to save, send, and manage your invoices effortlessly. For recurring invoices or e-mail sending, you need to login too.'
            },
            {
                question: 'What features does InvoiceHappens offer?',
                answer: 'InvoiceHappens offers instant invoice creation, 1-Click Cloud Sync, Apple-inspired design, recurring invoices, localization, and butter-smooth performance.'
            },
            {
                question: 'Why was InvoiceHappens created?',
                answer: 'InvoiceHappens was built because we were tired of complicated, expensive invoicing software. When renting office space for fellow entrepreneurs, we had to pay for a bloated admin package just to send a few invoices. The alternatives had ugly interfaces, hidden fees, and frustrating setups. InvoiceHappens is different—designed by entrepreneurs, for entrepreneurs.'
            },
            {
                question: 'What\'s your goal with InvoiceHappens?',
                answer: 'Our moonshot goal is to help entrepreneurs send 1 million invoices for free. InvoiceHappens isn\'t just software—it\'s a movement to make invoicing effortless for everyone.'
            }
        ]
    },
    nl: {
        title: 'Veelgestelde vragen',
        subtitle: 'We zijn er om je te helpen met al je vragen. Als je niet vindt wat je zoekt, bezoek dan onze',
        completeFaqLink: 'complete FAQ-pagina',
        items: [
            {
                question: 'Wat is InvoiceHappens?',
                answer: 'InvoiceHappens is een moeiteloos elegant factureringsplatform speciaal ontworpen voor ondernemers. Het stelt je in staat om direct facturen te maken en te verzenden zonder aanmeldingen, zonder kosten en met een mooie, intuïtieve interface.'
            },
            {
                question: 'Is het echt gratis?',
                answer: 'Ja, echt! De eerste 100.000 ondernemers kunnen gratis factureren. Geen verborgen kosten, geen freemium-valkuilen en geen ingewikkelde opzet. Wij geloven dat elke ondernemer een eenvoudige, elegante manier verdient om te factureren zonder een cent te betalen.'
            },
            {
                question: 'Moet ik een account aanmaken?',
                answer: 'Er is geen account nodig om te beginnen met factureren. Begin gewoon met typen en je factuur is binnen enkele seconden klaar. Je kunt optioneel onze 1-Click Cloud Sync gebruiken om je facturen moeiteloos op te slaan, te verzenden en te beheren. Voor terugkerende facturen of e-mail verzenden moet je ook inloggen.'
            },
            {
                question: 'Welke functies biedt InvoiceHappens?',
                answer: 'InvoiceHappens biedt directe factuurcreatie, 1-Click Cloud Sync, Apple-geïnspireerd ontwerp, terugkerende facturen, lokalisatie en soepele prestaties.'
            },
            {
                question: 'Waarom is InvoiceHappens gemaakt?',
                answer: 'InvoiceHappens is gebouwd omdat we genoeg hadden van ingewikkelde, dure facturatiesoftware. Bij het huren van kantoorruimte voor collega-ondernemers moesten we betalen voor een opgeblazen administratiepakket om slechts enkele facturen te verzenden. De alternatieven hadden lelijke interfaces, verborgen kosten en frustrerende opzet. InvoiceHappens is anders—ontworpen door ondernemers, voor ondernemers.'
            },
            {
                question: 'Wat is jullie doel met InvoiceHappens?',
                answer: 'Ons grote doel is om ondernemers te helpen 1 miljoen facturen gratis te verzenden. InvoiceHappens is niet alleen software—het is een beweging om factureren moeiteloos te maken voor iedereen.'
            }
        ]
    }
}; 